import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Logging } from '../../../meet-logger/services/logging/logging.service';
import { version } from 'src/environments/version';
import { NotifierService } from 'angular-notifier';
import { TranslateService } from '@ngx-translate/core';

const logContext = 'ReportIssueModalComponent';
@Component({
  selector: 'app-report-issue-modal',
  templateUrl: './report-issue-modal.component.html',
  styleUrls: ['./report-issue-modal.component.scss'],
})
export class ReportIssueModalComponent implements OnInit {
  logs: any[];
  isStandAlone = true;
  // currently we are not implementing the follow-up admin. But might change in future
  adminName: string;
  adminEmail: string;
  reportIssueHostName = "account-portal"; // This is a key obtained from platform-api-logs via https://mitel.atlassian.net/browse/CL-12173
  helpDocumentationElem = null;
  showHelp = false;
  // feedbackLink =
  //   'https://mitel.uservoice.com/forums/931507-end-user-feedback?category_id=457729';
  enableFaq = false;
  @ViewChild('helpText') helpText: ElementRef<any>;

  constructor(
    public dialogRef: MatDialogRef<ReportIssueModalComponent>,
    private elem: ElementRef,
    private alert: NotifierService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    Logging.info(`[${logContext}] ngOnInit invoked`);
    this.logs = this.getLogs();
  }

  ngAfterViewInit() {
    this.setHelpLink();
    // When dialog opens, set focus on the Title input
    const element = this.elem.nativeElement.querySelector(
      '#report-title-input'
    );
    if (!!element) {
      element.focus();
    }
  }

  onFormProcessComplete(success: boolean): void {
    Logging.info(`[${logContext}] onFormProcessComplete success=${success}`);
    if (success) {
      this.alert.notify('success', this.translateService.instant('report-problem.reportSendSuccess'));
    } else {
      this.alert.notify('error', this.translateService.instant('report-problem.reportSendFailure'));
    }
  }

  onError(error: Error): void {
    Logging.info(
      `[${logContext}] onError failure sending problem report`,
      error
    );
    // this.echoBannerError('cl_im.reportSendFailure');   TODO error toast!!!!!!!
  }

  close() {
    this.dialogRef.close();
  }

  private setHelpLink() {
    this.helpDocumentationElem =
      this.helpText?.nativeElement.getElementsByTagName('a')[0];
    if (this.helpDocumentationElem) {
      // this.helpDocumentationElem.href = AppUtil.getHelpUrl();
      this.helpDocumentationElem.target = '_blank';
      this.helpDocumentationElem.style.setProperty(
        'text-decoration',
        'underline'
      );
    }
  }

  getLogs() {
    // stuff our context data on top of the logs
    return [
      {
        context: {
          appName: 'cl-accounts-web', //environment.appTitle,
          version: version,
          client: navigator.userAgent,
          url:window.location.href,
        },
      },
      ...Logging.getLogs().map(
        (log) =>
          `${log.datetime} ${log.logType.toUpperCase()} ${log.source} ${
            log.message
          } ${!!log.data ? log.data : ''}`
      ),
    ];
  }
}
